import { gql } from '@apollo/client';

export const GET_SHOW_CAPACITY_STATUS = gql`
  query GetShowCapacityStatus {
    vm {
      configItem(key: "show-capacity-status") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;
